import http from "@/helper/http";
import {BaseVO, GetByIdBO, PaginationVO} from "@/model/global";
import {useMutation, useQuery} from "@tanstack/react-query";
import {ExecuteBO, ReviewStatusVO} from "@/service/instance.s";
import {PaymentPO} from "@/model/finance";
import {WritePaymentForm} from "@/pages/Payment/WritePayment";

export enum PaymentEnum {
    GetPaymentPage = "/payment/getPaymentPage",
    GetPayment = "/payment/getPayment",
    CreatePayment = "/payment/createPayment",
    UpdatePayment = "/payment/updatePayment",
    ConfirmPayment = '/payment/confirmPayment'
}

export interface PaymentPageBO {
    keyword?: string;
}

export interface PaymentPageVO extends ReviewStatusVO, PaymentPO {
}

export interface PaymentVO extends PaymentPO {
    applyNo: string
}

export const useQueryPaymentPage = () => useMutation({
    mutationFn: (data: PaymentPageBO) => http.post<BaseVO<PaginationVO<PaymentPageVO>>>({
        url: PaymentEnum.GetPaymentPage,
        data: data,
    }),
})

export const useCreatePayment = () => useMutation({
    mutationFn: (data: WritePaymentForm) => http.put({url: PaymentEnum.CreatePayment, data}),
})

export const useConfirmPayment = () => useMutation({
    mutationFn: (data: ExecuteBO) => http.post<BaseVO<null>>({url: PaymentEnum.ConfirmPayment, data}),
})

export const useUpdatePayment = () => useMutation({
    mutationFn: (data: WritePaymentForm) => http.post({url: PaymentEnum.UpdatePayment, data: {...data?.payments[0], ...data}}),
})

export const useQueryPayment = (params: GetByIdBO, enabled = true) => useQuery<BaseVO<PaymentVO>>({
    queryKey: [params.id], queryFn: () => http.get<BaseVO<PaymentVO>>({
        url: PaymentEnum.GetPayment,
        params: params
    }),
    enabled
})


